// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"LocationPermissionModal_modalBody__2HfTI","modalFooter":"LocationPermissionModal_modalFooter__eqgsq"};